/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UtilizationChartFactType {
    COUNT = 'COUNT',
    UTILIZATION = 'UTILIZATION',
    OUTPUT = 'OUTPUT'
}


export function UtilizationChartFactTypeFromJSON(json: any): UtilizationChartFactType {
    return UtilizationChartFactTypeFromJSONTyped(json, false);
}

export function UtilizationChartFactTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UtilizationChartFactType {
    return json as UtilizationChartFactType;
}

export function UtilizationChartFactTypeToJSON(value?: UtilizationChartFactType | null): any {
    return value as any;
}

